import React, { Component } from "react"
import ReactDOM from "react-dom"
import Modal from "react-animated-modal"
import { disableEnterKeyToSubmitForm, escKeyToCloseForm, removeKeyPressListener } from "../Helper/helper"

class BaseModalPortal extends React.Component {
    constructor(props) {
        super(props)
        if ($(`#${props.portalId}`).length == 0) {
            $('body').prepend(`<div id="${props.portalId}" class="${props.portalId}" style="z-index: ${this.props.zIndex + this.props.zIndexOffset}; position: absolute"></div>`)
        }
        this.portalRoot = document.getElementById(props.portalId)
        this.el = document.createElement("div")
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el)
    }
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el)
    }
    onClose = () => {}
    render() {
        const { children } = this.props
        return ReactDOM.createPortal(children, this.el)
    }
}
class BaseModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            selectedReason: null,
            otherReason: null,
            errorMessage: null,
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true
        removeKeyPressListener(this)
    }
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        disableEnterKeyToSubmitForm(this)
        escKeyToCloseForm(this)
        this.unmounted = false
    }
    #onClose = () => {
        this.props.onClose && this.props.onClose()
    }

    // Parent to call this to dismiss the modal
    close() {
        this.props.onClose && this.props.onClose()
    }
    
    setErrorMessage(errorMessage) {
        this.setState({
            errorMessage
        })
        setTimeout(() => {
            this.setState({
                errorMessage: null
            })  
        }, 3000)
    }

    render() {
        return (
            <BaseModalPortal {...this.props}>
                <Modal
                    visible={true}
                    closemodal={this.#onClose}
                    type="pulse">
                    {this.props.body}
                    {this.props.children}
                    <div className="text-danger" style={{margin: "10px"}}>
                        <i>{this.state.errorMessage}</i>
                    </div>
                </Modal>
            </BaseModalPortal>
        )
    }
}
BaseModal.defaultProps = {
    portalId: "BaseModal_" + Math.random(),
    body:null,
    zIndex: 5000,
    zIndexOffset: 0,
}
export default BaseModal